import Vue from 'vue'
import VueRouter from 'vue-router'
// const Layout = () => import('@/views/Layout')
const Home = () => import('@/views/home/home')
const Login = () => import('@/views/login/login')
const Mycollect = () => import('@/views/mycollect/mycollect')
const DetailsList = () => import('@/views/detailsList/detailsList')
const Sos = () => import('@/views/sos/sos')
const AuthCamera = () => import('@/views/authCamera/authCamera')

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'login',
        component: Login,

    }, {
        path: '/home',
        name: 'home',
        component: Home
    }, {
        path: '/mycollect',
        name: 'mycollect',
        component: Mycollect
    }, {
        path: '/detailsList',
        name: 'detailsList',
        component: DetailsList
    }, {
        path: '/sos',
        name: 'sos',
        component: Sos
    }, {
        path: '/authCamera',
        name: 'authCamera',
        component: AuthCamera
    }


]

const router = new VueRouter({
    mode: 'history',
    // mode: 'hash',
    routes,
    // 指定该钩子函数，返回坐标值即可
    // scrollBehavior(to, from, savedPosition) {

    //     return {
    //         x: 0,
    //         y: 0
    //     }
    // }
})

export default router